<template>
  <div>
    <v-row dense class="mx-1">
      <px-cadastro-grupo @change="onClickRefresh">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">
            <v-icon left>mdi-plus</v-icon>
            Grupo
          </v-btn>
        </template>
      </px-cadastro-grupo>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um grupo" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import CadastroGrupo from './CadastroGrupo.vue';

export default {
  methods: {
    onClickRefresh() {
      this.$emit('refresh');
    },
    onChangeSearchText() {
      this.$emit('change', this.buildFilter());
    },
    buildFilter() {
      let filter = '';
      if (this.searchText) {
        const value = this.searchText.toLowerCase().replaceAll('"', '\\"').replaceAll('\'', '\\\'');
        filter += `descricao like '%${value}%' or departamento.descricao like '%${value}%'`;
      }
      return filter;
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
  components: {
    pxCadastroGrupo: CadastroGrupo,
  },
};
</script>
